import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body16BoldStyles,
  smallcapsRegular14Styles,
} from "@constants/typography"
import { RecentProduct } from "@redux/types"
import { getProductURL } from "@utils/urls"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  padding: 12px;
  border: solid 1px ${colors.dividerLineGray};

  @media ${breakpoints.tablet} {
    width: calc((100% / 2) - 10px);
  }

  @media ${breakpoints.laptop} {
    width: 400px;
    margin-bottom: 20px;
  }
`

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 86px;
  height: 86px;
  margin-right: 16px;
`

const Image = styled.img`
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
`

const Details = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  display: flex;
  width: 100%;
`

const Name = styled.div`
  ${body16BoldStyles}
  margin-bottom: 6px;
  padding-right: 24px;

  @media ${breakpoints.laptop} {
    padding-right: 0;
  }
`

const PriceWrapper = styled.div`
  justify-content: flex-start;
  display: flex;
`

const RetailPrice = styled.div`
  ${smallcapsRegular14Styles}
  opacity: 0.3;
  margin-right: 6px;
  text-decoration: line-through;
  color: ${colors.mediumGray};
`

const Price = styled.div`
  ${smallcapsRegular14Styles}
  color: ${colors.mediumGray};
`

export interface RecentItemProps extends RecentProduct {}

const RecentItem: React.FC<RecentItemProps> = ({
  compareAtPrice,
  image,
  price,
  productName,
  productSlug,
}) => {
  return (
    <Container to={getProductURL(productSlug)}>
      <ImageContainer>
        <Image src={image} />
      </ImageContainer>
      <Details>
        <Name>{productName}</Name>
        <PriceWrapper>
          {compareAtPrice && <RetailPrice>{compareAtPrice}</RetailPrice>}
          <Price>{price}</Price>
        </PriceWrapper>
      </Details>
    </Container>
  )
}

export default RecentItem
